module.exports = __webpack_public_path__ + "files/b3b0f427a78456957b3e78f2fae14644.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/nature-3.png
// module id = 1463
// module chunks = 60